module.exports = __webpack_public_path__ + "static/media/hqv_focus_finger.b40a9372.gif";